import React from "react";
import { Modal, Form, Input, Button, Spin, message, Steps } from "antd";
import { formItemLayout, tailFormItemLayout } from "$ACTIONS/constantsData";
import { dateFormat, formatSeconds } from "$ACTIONS/util";
import { Cookie } from "$ACTIONS/helper";
import { post, get, patch } from "$ACTIONS/TlcRequest";
import { emailReg } from "$ACTIONS/reg";
import { ApiPort, APISETS } from "$ACTIONS/TLCAPI";
import { otpNumReg } from "$ACTIONS/reg";
import Router from "next/router";
import ExceedVerify from "@/OTP/ExceedVerify";
import classNames from "classnames";
import { mailConversion } from "$ACTIONS/util";
import { setOtpPiwikName } from "$ACTIONS/piwikData";
const { Item } = Form;
const { Step } = Steps;
class EmailVerify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            remainingTime: -1,
            emailVisible: true,
            exceedVisible: false, // otp 超過驗證次數判斷
            buttonStatus: false,
            verifiyArea: false,
            piwikType: setOtpPiwikName(this.props.otpParam),
        };

        this.EmailVerify = this.EmailVerify.bind(this); // 发送验证码
        this.checkUrlVerifyCode = this.checkUrlVerifyCode.bind(this); // 验证手机号
        this.startCountDown = this.startCountDown.bind(this); // 倒计时
        this.timeTimer = null; // 倒计时Timer
    }
    componentDidMount() {
        this.props.otpParam && this.props.visible && this.getEmailOTPAttempts();
        if (
            this.props.otpParam === "login-otp" &&
            this.props.kindOfVerifications === "OTP"
        ) {
            global.Pushgtagpiwikurl &&
                global.Pushgtagpiwikurl(
                    "login_security_verification_email_verification",
                    "Login Security Verification Email Verification"
                );
        } else if (
            this.props.otpParam === "login-otp" &&
            this.props.kindOfVerifications === "Revalidate"
        ) {
            global.Pushgtagpiwikurl &&
                global.Pushgtagpiwikurl(
                    "reset_password_email_verification",
                    "Reset Password Email Verification"
                );
        } else if (this.props.otpParam === "withdrawal-otp") {
            global.Pushgtagpiwikurl &&
                global.Pushgtagpiwikurl(
                    "withdraw_otp_email_verification",
                    "Withdrawal Verification"
                );
        }
    }
    //流程修改為Server發送OTP後，若在countdown時間內離開OTP驗證畫面再回來，需要重新請求Server發送，不可回到倒數頁面
    // componentDidUpdate(prevProps, prevState) {
    //     if (prevProps.visible !== this.props.visible) {
    //         this.props.otpParam &&
    //             this.props.visible &&
    //             this.getEmailOTPAttempts();
    //         Cookie.Get(`${this.props.otpParam}emailTime`) !== "" && this.props.visible
    //             ? this.startCountDown()
    //             : clearInterval(this.timeTimer);
    //     }
    // }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.exceedVisible !== this.state.exceedVisible && this.state.exceedVisible) {
            if (this.props.otpParam === "login-otp" && this.props.kindOfVerifications === "OTP") {
                global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("exceed5times_otp", "Exceed 5 times OTP");
            } else if (this.props.otpParam === "withdrawal-otp") {
                global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("withdrawal_verify_exceed_popup", "Exceed Verification");
            }
        }
    }
    componentWillUnmount() {
        clearInterval(this.timeTimer);
    }
    /**
     * 获取邮箱验证次数
     */
    getEmailOTPAttempts = () => {
        const { otpParam, kindOfVerifications } = this.props;
        if (
            otpParam == "memberProfile-otp" ||
            otpParam == "login-otp" ||
            otpParam == "withdrawal-otp"
        ) {
            this.setState({ isLoading: true });
            get(
                ApiPort.GETOTPAttempts +
                    `&channelType=${"Email"}&serviceAction=${kindOfVerifications}`
            )
                .then((res) => {
                    this.setState({ isLoading: false });
                    if (res && res.result) {
                        if (res.result < 1) {
                            this.setState({
                                emailVisible: false,
                                exceedVisible: true,
                            });
                        } else if (res.result) {
                            this.props.setEmailAttemptRemaining(res.result);
                        }
                    }
                })
                .catch((error) => {
                    console.log("获取邮箱验证次数 error:", error);
                    this.setState({ isLoading: false });
                });
        }
    };
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.checkUrlVerifyCode(values.verifyCode);
            }
        });
    };
    startCountDown() {
        let times = 600;
        this.setState({ remainingTime: times });
        clearInterval(this.timeTimer);
        if (Cookie.Get(`${this.props.otpParam}emailTime`)) {
            const emailTime = Cookie.Get(`${this.props.otpParam}emailTime`);
            let lastSeconds = parseInt(times - (Date.now() - emailTime) / 1000);
            this.setState({ buttonStatus: true, verifiyArea: true });
            this.timeTimer = setInterval(() => {
                if (lastSeconds <= 0) {
                    Cookie.Delete(`${this.props.otpParam}emailTime`);
                    clearInterval(this.timeTimer);
                    //this.setState({ buttonStatus: false });
                    if (this.props.otpParam) {
                        this.props.form.setFieldsValue({ verifyCode: "" }); // 輸入匡改為空值
                    }
                }
                this.setState({ remainingTime: lastSeconds-- });
            }, 1000);
        }
    }
    EmailVerify() {
        const promiseVerification = this.props.form.validateFields([
            "emailAddress",
        ]);
        promiseVerification.then(() => {
            const { kindOfVerifications } = this.props;
            let EmailData = {
                serviceAction: kindOfVerifications,
                siteId: 37,
            };

            const sendEmailCode = () => {
                this.setState({ isLoading: true });
                post(ApiPort.POSTEmailVerifyAPI, EmailData)
                    .then((res) => {
                        const { piwikType } = this.state;
                        if (this.props.otpParam === "withdrawal-otp" && piwikType) {
                            Pushgtagdata(
                                `${piwikType}_Verfication`,
                                "Email Verfication",
                                `${piwikType}_Verfication_C_Email`,
                            ); 
                        }

                        this.setState({ isLoading: false });
                        if (res.isSuccess == true && res.result.isSent) {
                            message.success("ส่งสำเร็จ"); //发送成功
                            Cookie.Create(
                                `${this.props.otpParam}emailTime`,
                                Date.now(),
                                10
                            );
                            this.startCountDown();
                        } else if (res.isSuccess == false) {
                            const { description, errorCode } = res.errors[0];
                            if (
                                this.props.otpParam == "login-otp" ||
                                this.props.otpParam == "memberProfile-otp" ||
                                this.props.otpParam == "withdrawal-otp"
                            ) {
                                /*  -loginotp & 重置密码 
                                    -memberProfile-otp
                                    -withdrawal-otp
                                    超过请求次数
                                */
                                if (
                                    errorCode == "REVA0001" ||
                                    errorCode == "VAL18015"
                                ) {
                                    this.setState({ emailVisible: false, exceedVisible: true });
                                    return;
                                } else {
                                    message.error(
                                        description ||
                                            "การส่งล้มเหลว โปรดลองอีกครั้งภายหลังหรือติดต่อฝ่ายบริการลูกค้า" //发送失败，请稍后在尝试或联系客服!
                                    );
                                }
                            } else {
                                message.error(
                                    description ||
                                        "การส่งล้มเหลว โปรดลองอีกครั้งภายหลังหรือติดต่อฝ่ายบริการลูกค้า" //发送失败，请稍后在尝试或联系客服!
                                );
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("POSTEmailVerifyAPI" + error);
                    });
            };

            sendEmailCode();
        });
    }
    checkUrlVerifyCode(code) {
        if (!otpNumReg.test(code))
            return global.showResultModal("รููปแบบไม่ถูกต้อง", false); //格式错误
        let EmailData = {
            serviceAction: this.props.kindOfVerifications,
            verificationCode: code,
            siteId: 37,
        };

        this.setState({ isLoading: true });
        patch(ApiPort.PATCHEmailVerifyAPI, EmailData).then((res) => {
            if (res) {
                const { piwikType } = this.state;
                if (this.props.otpParam === "withdrawal-otp" && piwikType) {
                    Pushgtagdata(
                        `${piwikType}_Verfication`,
                        "Submit OTP",
                        `${piwikType}_Verfication_S_EmailOTP`,
                        res?.result?.isVerified ? 2 : 1,
                        [
                            {
                                customVariableKey: res?.result?.isVerified
                                    ? false
                                    : `Email_Verify_S_OTP_ErrorMsg`,
                                customVariableValue: res?.result?.isVerified
                                    ? false
                                    : "คุณทำการยืนยันข้อมูลเกินที่กำหนด",
                            },
                        ]
                    );
                } else if (this.props.otpParam === "login-otp" && piwikType) {
                    Pushgtagdata(
                        `${piwikType}_Verfication`,
                        "Submit OTP",
                        `${piwikType}_Verfication_S_EmailOTP`,
                        res?.result?.isVerified ? 2 : 1,
                        [
                            {
                                customVariableKey: res?.result?.isVerified
                                    ? false
                                    : `${piwikType}_Verfication_S_EmailOTP_ErrorMsg`,
                                customVariableValue: res?.result?.isVerified
                                    ? false
                                    : "คุณทำการยืนยันข้อมูลเกินที่กำหนด",
                            },
                        ]
                    );
                }

                let { isSuccess, result = {} } = res || {};
                this.setState({ isLoading: false });
                if (isSuccess && result.isVerified) {
                    global.showResultModalWithColor("ยืนยันสำเร็จ", true); //验证成功
                    // if (result?.queleaReferreeStatus) {
                    //     this.props.GetThroughoutVerification &&
                    //         this.props.GetThroughoutVerification();
                    // }
                    setTimeout(() => {
                        //1st提款驗證
                        if (this.props.otpParam === "withdrawal-otp") {
                            this.props.correctMemberInfo();
                            if (this.props.visible) {
                                this.props.onClose(); // 關閉email驗證
                                if (this.props.isNext) {
                                    this.props.nextStep(); // 開啟電話驗證
                                }
                            }
                            return;
                        } else if (
                            this.props.otpParam === "login-otp" &&
                            this.props.kindOfVerifications === "Revalidate"
                        ) {
                            this.props.changeVerify(false, false, false); // 關閉彈窗
                            this.props.setReadStep(4);
                        } else if (
                            this.props.otpParam === "memberProfile-otp"
                        ) {
                            this.props.closeModal();
                            this.props.correctMemberInfo();
                        } else if (
                            this.props.otpParam === "login-otp" &&
                            this.props.kindOfVerifications === "OTP"
                        ) {
                            localStorage.setItem("login-otp", true); // 驗證成功
                            this.props.changeVerify(false, false, false); // 關閉彈窗
                            Router.push("/");
                        }
                    }, 3000);
                    return;
                } else {
                    if (isSuccess && !result.isVerified) {
                        //wrong OTP code，status: 200
                        if (result.remainingAttempt) {
                            this.props.form.setFields({
                                verifyCode: {
                                    value: "",
                                    errors: [
                                        new Error(
                                            "คุณกรอกรหัส  OTP ไม่ถูกต้อง โปรดตรวจสอบแล้วทำการกรอกใหม่อีกครั้ง"
                                        ),
                                    ],
                                },
                            });
                            this.props.setEmailAttemptRemaining(
                                result.remainingAttempt
                            );
                            return;
                        } else {
                            // 超過驗證次數
                            this.setState({ emailVisible: false, exceedVisible: true });
                            return;
                        }
                    } else if (res?.errors?.length > 0) {
                        //expired OTP code，status: 400
                        if (res.errors[0].errorCode === "VAL18023") {
                            this.props.form.setFields({
                                verifyCode: {
                                    value: "",
                                    errors: [
                                        new Error(
                                            "รหัส  OTP นี้หมดอายุการใช้งานแล้ว กรุณาคลิกเพื่อขอรับรหัส OTP อีกครั้ง"
                                        ),
                                    ],
                                },
                            });
                        } else if (
                            res.errors[0].errorCode === "REVA0001" ||
                            res.errors[0].errorCode == "VAL18013"
                        ) {
                            // 超過驗證次數
                            this.setState({ emailVisible: false, exceedVisible: true });
                            return;
                        } else {
                            this.props.form.setFields({
                                verifyCode: {
                                    value: "",
                                    errors: [
                                        new Error(res.errors[0].description),
                                    ],
                                },
                            });
                        }
                        return;
                    }
                }
            }
        });
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const {
            exceedVisible,
            remainingTime,
            buttonStatus,
            verifiyArea,
            piwikType,
            emailVisible,
        } = this.state;
        const verificationCode = getFieldValue("verifyCode");
        const email = this.props.email;
        // const email = this.props.email && this.props.email.split('@')
        // const emailFormat = email && email[0].substr(0, Math.floor(email[0].length / 2)) + '*'.repeat(Math.round(email[0].length / 2)) + '@' + email[1]
        // console.log("remainingTime", remainingTime);
        // console.log("verifiyArea", verifiyArea);
        return (
            <React.Fragment>
                <Modal
                    className="general-modal verify-modal"
                    title={"ยืนยันข้อมูลอีเมล"} //邮箱验证
                    // style={this.props.style}
                    visible={emailVisible}
                    width={400}
                    footer={null}
                    centered={true}
                    closable={true}
                    maskClosable={
                        this.props.otpParam == "login-otp" ? false : true
                    }
                    onCancel={() => {
                        this.props.closeModal();
                    }}
                    zIndex={1500}
                >
                    <Spin
                        spinning={this.state.isLoading}
                        tip="กำลังโหลด กรุณารอสักครู่..." //加载中，请稍候...
                        style={{ backgroundColor: "initial" }}
                    >
                        {(this.props.kindOfVerifications === "Revalidate" ||
                            this.props.otpParam === "withdrawal-otp") && (
                            <div className="StepsBox">
                                <Steps current={0} size="small">
                                    <Step />
                                    <Step />
                                </Steps>
                            </div>
                        )}
                        <Form
                            className="verification-form-wrap"
                            {...formItemLayout}
                            onSubmit={this.handleSubmit}
                        >
                            <label
                                style={{
                                    font: "normal normal bold 14px/24px Noto Sans Thai",
                                    marginBottom: "5px",
                                    display: "block",
                                    color: "#222222",
                                }}
                            >
                                ยืนยันรหัส OTP
                            </label>
                            <div>
                                เพื่อความปลอดภัยของบัญชีคุณโปรดทำตามคำแนะนำด้านล่าง
                                เพื่อยืนยันอีเมลของคุณ
                                {/* 为了确保您帐户的安全，请按照以下说明验证您的电子邮件。 */}
                            </div>
                            <div className="line-distance" />
                            <Item label="อีเมล">
                                {/* 电子邮箱 */}
                                {getFieldDecorator("emailAddress", {
                                    initialValue: email || "",
                                    rules: [
                                        {
                                            required: true,
                                            message: "กรุณากรอกอีเมล", //请输入电子邮箱
                                        },
                                        {
                                            validator: (
                                                rule,
                                                value,
                                                callback
                                            ) => {
                                                if (value && !email) {
                                                    !emailReg.test(email) &&
                                                        callback(
                                                            "อีเมลไม่ถูกต้อง" //错误电邮格式
                                                        );
                                                }
                                                callback();
                                            },
                                        },
                                    ],
                                })(
                                    <Input
                                        size="large"
                                        placeholder="กรุณากรอกอีเมล" //请输入电子邮箱
                                        className="tlc-input-disabled"
                                        autoComplete="off"
                                        disabled={!!this.props.email}
                                    />
                                )}
                            </Item>
                            <div className="otp-cs-tip">
                                กรุณาติดต่อ
                                <span
                                    className="otp-cs"
                                    onClick={() => {
                                        global.PopUpLiveChat();
                                        piwikType &&
                                            Pushgtagdata(
                                                `${piwikType}_Verfication`,
                                                "Contact CS",
                                                `${piwikType}_Verfication_C_CS`
                                            );
                                    }}
                                >
                                    {" เจ้าหน้าที่ฝ่ายบริการ "}
                                </span>
                                หากคุณต้องการเปลี่ยนแปลงข้อมูล อีเมลที่ลงทะเบียน
                            </div>
                            {/* 如果您想更新电子邮箱，请联系我们的在线客服 */}

                            <Item label="รหัสยืนยัน">
                                {/* 验证码 */}
                                {getFieldDecorator("verifyCode", {
                                    rules: [
                                        {
                                            required: true,
                                            message: "กรุณากรอกรหัสยืนยัน", //请输入验证码！
                                        },
                                    ],
                                    getValueFromEvent: (event) => {
                                        return event.target.value.replace(
                                            /\D/g,
                                            ""
                                        );
                                    },
                                })(
                                    <Input
                                        addonAfter={
                                            remainingTime < 0 ? (
                                                <div
                                                    onClick={() => {
                                                        this.EmailVerify();
                                                    }}
                                                >
                                                    ส่ง{/* 发送 */}
                                                </div>
                                            ) : remainingTime > 0 ? (
                                                <div className="resend-disabled">
                                                    ส่งอีกครั้ง
                                                    <br />
                                                    {`ภายใน ${formatSeconds(
                                                        remainingTime
                                                    )} `}
                                                </div> //重发
                                            ) : (
                                                !remainingTime && (
                                                    <div
                                                        onClick={() => {
                                                            this.EmailVerify(
                                                                true
                                                            );
                                                        }}
                                                    >
                                                        ส่งรหัสอีกครั้ง
                                                        {/* 重新发送 */}
                                                    </div>
                                                )
                                            )
                                        }
                                        size="large"
                                        autoComplete="off"
                                        className={`OTP-input ${
                                            remainingTime > 0
                                                ? "disabled-time"
                                                : "abled-time"
                                        }`}
                                        placeholder="กรุณากรอกรหัส OTP  ที่ส่งไปยังอีเมลของคุณ" //请输入发送到您的电子邮件的 OTP。
                                        maxLength={6}
                                    />
                                )}
                            </Item>
                            {verifiyArea && (
                                <Item {...tailFormItemLayout}>
                                    <div className="btn-wrap otp-btn-wrap">
                                        <Button
                                            size="large"
                                            type="primary"
                                            htmlType="submit"
                                            className={classNames({
                                                GreenBtn:
                                                    verificationCode &&
                                                    verificationCode.length >=
                                                        6 &&
                                                    buttonStatus,
                                                ["email-btn"]: true,
                                            })}
                                            disabled={
                                                verificationCode &&
                                                verificationCode.length >= 6 &&
                                                buttonStatus
                                                    ? false
                                                    : true
                                            }
                                        >
                                            ทำการยืนยันตอนนี้ {/* 立即验证 */}
                                        </Button>
                                    </div>
                                </Item>
                            )}
                            {this.props.otpParam && (
                                <center className="verify-remaining">
                                    คุณยังสามารถยืนยันข้อมูลได้อีก（
                                    <span className="blue">
                                        {this.props.emailattemptRemaining}
                                    </span>
                                    ）ครั้ง
                                </center> //您还有(X)次尝试机会
                            )}
                            {verifiyArea && this.props.isAllowChange && (
                                <div className="changeVerify">
                                    <span
                                        onClick={() => {
                                            this.props.closeModal();
                                            if (
                                                this.props.otpParam ===
                                                "login-otp"
                                            ) {
                                                Pushgtagdata(
                                                    `${piwikType}_Verfication`,
                                                    "Switch to Phone Verification ",
                                                    `${piwikType}_Verfication_C_Change_Verification`
                                                );
                                            } else if (
                                                this.props.otpParam ===
                                                "withdrawal-otp"
                                            ) {
                                                Pushgtagdata(
                                                    `${piwikType}_Verfication`,
                                                    "Skip Verification",
                                                    `${piwikType}_Verfication_C_Skip`
                                                );
                                            }
                                        }}
                                    >
                                        {this.props.otpParam == "login-otp"
                                            ? "เปลี่ยนวิธียืนยันข้อมูล"
                                            : "ยืนยันภายหลัง"}
                                    </span>
                                </div>
                            )}
                        </Form>
                    </Spin>
                </Modal>

                {exceedVisible /* otp 超過次數彈窗 */ && (
                    <ExceedVerify
                        exceedVisible={exceedVisible}
                        times={this.props.times}
                        headTitle={
                            `ยืนยันข้อมูลเกินที่กำหนด` //超过尝试次数
                        }
                        // offset={{ left: "5%" }}
                        otpParam={this.props.otpParam}
                        btnInfo={this.props.kindOfVerifications}
                        onCancel={() => {
                            this.setState({ exceedVisible: false });
                            if (
                                this.props.otpParam == "memberProfile-otp" ||
                                this.props.otpParam == "withdrawal-otp"
                            ) {
                                this.props.closeModal();
                            } else if (this.props.otpParam == "login-otp") {
                                this.props.changeVerify(false, false, false);
                                setTimeout(() => {
                                    global.globalExit();
                                    Router.push("/");
                                }, 1500);
                            }
                        }}
                    />
                )}
            </React.Fragment>
        );
    }
}

export default Form.create({ name: "EmailVerify" })(EmailVerify);
